import React, { useMemo } from 'react';
import { Checkbox, MenuDropdown } from '@peoplegrove/pg-components';
import { useConversationFiltersContext } from '../context/ConversationFiltersContext';

const FILTER_OPTIONS = [
  { key: 'markedAsNotHelpful', label: 'Marked as not helpful' },
  { key: 'includeProductionHubs', label: 'Include production hubs' },
  { key: 'includeSuperadmin', label: 'Include Superadmins' },
  { key: 'includeClientAdmin', label: 'Include Client admins' },
  { key: 'includeNonAdminUsers', label: 'Include non-admin users' },
  { key: 'raisedTicket', label: 'Raised ticket' },
  { key: 'flaggedInternally', label: 'Flagged internally' },
];

const MoreFiltersDropdown = () => {
  const { pendingFilters, setConversationFilters } =
    useConversationFiltersContext();

  const menuItems = useMemo(
    () =>
      FILTER_OPTIONS.map(({ key, label }) => ({
        key,
        preventCloseOnClick: true,
        label: (
          <Checkbox
            checked={Boolean(pendingFilters[key])}
            onChange={checked => setConversationFilters(key, checked)}
            style={{ margin: 0 }}
          >
            {label}
          </Checkbox>
        ),
      })),
    [pendingFilters, setConversationFilters]
  );

  return (
    <MenuDropdown
      items={menuItems}
      position="bottom"
      buttonProps={{
        size: 'small',
        icon: 'pg-filter-o',
        type: 'tertiary',
      }}
    >
      Filters
    </MenuDropdown>
  );
};

export default MoreFiltersDropdown;
